module.exports = require("asn1-ts/dist/node/functional");